import { decryptText } from '../utils/ObjectUtil'

export const SHIRT_COLOR = [
  'BLUE',
  'WHITE',
  'ORANGE',
  'YELLOW GOLD',
  'PINK',
  'GREEN',
]
export const WORK_SITE = ['PTY MAIN', 'PIPC 12']

// To get the encrypted data:
// {Object.keys(employees['pty-family-day-2025']).map((k) => (
//   <>
//     {`"${k}": "${encryptText(employees['pty-family-day-2025'][k])}",`}
//     <br />
//   </>
// ))}
export const employees = {
  // sample
  // 'event-slug': {
  //   // // fullname format: lastname, firstname
  //   // employeeId: 'fullName|maxParticipants|site', // encrypted value
  // },
  'pty-family-day-2025': {
    '198900048':
      'U2FsdGVkX18W9G7ubevjAS4KAGCVZjoyrUoKQOQe6DWEImihzmujQjsC5RrhN5u50lwIIvquqvtvsF2Tmn61Mg==',
  },
}

export const getEmployee = (slug: string, idNo: string) => {
  if (!(slug in employees)) return {}
  const pad = Object.keys(employees[slug])[0].length
  const id = idNo.padStart(pad, '0')
  const hashText = employees[slug][id] || null
  if (!hashText) return {}

  const decryptedText = decryptText(hashText).split('|')

  return {
    name: decryptedText[0],
    max: decryptedText[1],
    site: decryptedText[2],
  }
}
